import { Tag } from 'antd';

import { Schemas } from '@api-client/generated/types';
import { ACCESS_RIGHTS } from '@constants';

import * as S from './styled';

type Props = {
  rights: Schemas.AccessRights;
};

/** Granted access rights rendered as calm, soft chips. Only granted rights are
 * shown; a member with every right collapses to a single "Full access" chip so
 * the common case stays scannable, and a member with none shows a muted
 * placeholder. */
const AccessRightsChips = ({ rights }: Props) => {
  const granted = ACCESS_RIGHTS.filter(({ key }) => rights[key]);

  if (!granted.length) {
    return <S.MutedText>No access</S.MutedText>;
  }

  if (granted.length === ACCESS_RIGHTS.length) {
    return (
      <Tag color="success" bordered={false}>
        Full access
      </Tag>
    );
  }

  return (
    <>
      {granted.map(({ key, label }) => (
        <Tag key={key} color="success" bordered={false}>
          {label}
        </Tag>
      ))}
    </>
  );
};

export default AccessRightsChips;
